import axios from "axios";
import Env from "@/env";

const prefixs_api = ["/customer/api", "/public/api", "/application/api"];
const { proxy_enabled, api_host, chatwoot_api_access_token } = Env;

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    if (!proxy_enabled) {
      if(prefixs_api.some(prefix => !!config.url && config.url.slice(0, prefix.length) === prefix)) {
        config.url = `${api_host}${config.url}`;
      }
    }
    if(!config.headers.has("api_access_token")) {
      config.headers["api_access_token"] = chatwoot_api_access_token;
    }
    if(!config.headers.has("api-access-token")) {
      config.headers["api-access-token"] = chatwoot_api_access_token;
    }
    config.headers["X-Powered-By"] = "SaneSong Ltd";
    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;
